// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__taodA","row":"Node_row__2JTi1","label":"Node_label__2Jyp-","footer":"Node_footer__2NcDf"};